import React from 'react';

export const ViewColumn = ({
  className,
  color,
  height,
  width,
}: {
  className?: string;
  color?: string;
  height?: string;
  width?: string;
}) => (
  <svg
    width={width || '25'}
    height={height || '24'}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className || ''}
  >
    <g mask="url(#mask0_216_7140)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.39775 4.96816V8.90945H9.53546V4.96816H5.39775ZM4.94775 3.01816C4.11933 3.01816 3.44775 3.68973 3.44775 4.51816V9.35945C3.44775 10.1879 4.11933 10.8595 4.94775 10.8595H9.98546C10.8139 10.8595 11.4855 10.1879 11.4855 9.35945V4.51816C11.4855 3.68973 10.8139 3.01816 9.98546 3.01816H4.94775Z"
        fill={color || '#7D7A9A'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.3777 4.96816V8.90945H19.5154V4.96816H15.3777ZM14.9277 3.01816C14.0993 3.01816 13.4277 3.68973 13.4277 4.51816V9.35945C13.4277 10.1879 14.0993 10.8595 14.9277 10.8595H19.9654C20.7939 10.8595 21.4654 10.1879 21.4654 9.35945V4.51816C21.4654 3.68973 20.7939 3.01816 19.9654 3.01816H14.9277Z"
        fill={color || '#7D7A9A'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.39775 15.0905V19.0318H9.53546V15.0905H5.39775ZM4.94775 13.1405C4.11933 13.1405 3.44775 13.8121 3.44775 14.6405V19.4818C3.44775 20.3103 4.11933 20.9818 4.94775 20.9818H9.98546C10.8139 20.9818 11.4855 20.3103 11.4855 19.4818V14.6405C11.4855 13.8121 10.8139 13.1405 9.98546 13.1405H4.94775Z"
        fill={color || '#7D7A9A'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.3777 15.0905V19.0318H19.5154V15.0905H15.3777ZM14.9277 13.1405C14.0993 13.1405 13.4277 13.8121 13.4277 14.6405V19.4818C13.4277 20.3103 14.0993 20.9818 14.9277 20.9818H19.9654C20.7939 20.9818 21.4654 20.3103 21.4654 19.4818V14.6405C21.4654 13.8121 20.7939 13.1405 19.9654 13.1405H14.9277Z"
        fill={color || '#7D7A9A'}
      />
    </g>
  </svg>
);
